// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1M9bn","rootSuccess":"CompleteLink_rootSuccess__1OvXn","rootFailure":"CompleteLink_rootFailure__1pKtv","isDisabled":"CompleteLink_isDisabled__1pKQ0"};